import { FieldTrim } from '../data-set/enum';
export default function trimString(value, fieldTrim) {
    if (fieldTrim) {
        switch (fieldTrim) {
            case FieldTrim.both:
                return value.trim();
            case FieldTrim.left:
                return value.trimLeft();
            case FieldTrim.right:
                return value.trimRight();
            default:
        }
    }
    return value;
}
